// Shared actions

import { Payload } from "vuex-pathify"
import _ from "lodash"

const modelTextArrayAppend = ({ commit, state }, path) => {
  if (state.model === undefined) {
    throw new Error("Vuex state does not contain model")
  }

  const array = _.get(state.model, path)

  if (!Array.isArray(array)) {
    throw new Error(
      "Text array append failed, specified path does not represent array"
    )
  }

  array.push(null)

  commit("SET_MODEL", new Payload(null, path, array))
}

const modelTextArrayRemove = ({ commit, state }, { index, path }) => {
  if (state.model === undefined) {
    throw new Error("Vuex state does not contain model")
  }

  const array = _.get(state.model, path)

  if (!Array.isArray(array)) {
    throw new Error(
      "Text array update failed, specified path does not represent array"
    )
  }
  if (array[index] === undefined) {
    throw new Error("Text array update failed, specified index not found")
  }

  array.splice(index, 1)

  commit("SET_MODEL", new Payload(null, path, array))
}

const modelTextArrayUpdate = ({ commit, state }, { index, path, value }) => {
  if (state.model === undefined) {
    throw new Error("Vuex state does not contain model")
  }

  const array = _.get(state.model, path)

  if (!Array.isArray(array)) {
    throw new Error(
      "Text array update failed, specified path does not represent array"
    )
  }
  if (array[index] === undefined) {
    throw new Error("Text array update failed, specified index not found")
  }

  array[index] = value

  commit("SET_MODEL", new Payload(null, path, array))
}

export { modelTextArrayAppend, modelTextArrayRemove, modelTextArrayUpdate }
